<template>
  <dashboard-widget title="CASKING RATE" :zoomed="zoomed" :width="width" :enableDelete="enableDelete"
                      @zoom="$emit('zoom','DashboardCaskingSummary')"
                      @delete="$emit('delete','DashboardCaskingSummary')"
                      @close="$emit('close')">
    <v-btn-toggle v-model="period" mandatory @change="refresh" style="position:absolute;top:40px;left:10px" :style="zoomed?'top:60px':''">
      <v-btn x-small value="Last30Days">Last 30 days</v-btn>
      <v-btn x-small value="Monthly">This month</v-btn>
    </v-btn-toggle>
    <div class="text-center">
      <div ref="chart" class="d-inline-block" :style="zoomed?'height:420px;width:420px;margin-top:35px':'height:245px;width:245px;margin-top:25px'"
            @click="disableTo ? '' : $router.push({name:'InventoryCasks',query:{age:'1'}})"/>
    </div>
  </dashboard-widget>
</template>

<script>
import {format,add} from 'date-fns'

export default {
  name: 'DashboardCaskingSummary',
  props: {
    from: {type:String, required:true},
    to: {type:String, required:true},
    zoomed: {type:Boolean, required:false, default:false},
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false},
    disableTo: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      max: 0,
      dataGauge: null,
      period: 'Last30Days',

      chart: null,
      options: {minorTicks:5}
    }
  },
  watch: {
    from() {
      this.refresh();
    },
    to() {
      this.refresh();
    }
  },
  async mounted() {
    if (window.google) {
      window.google.charts.load('current', {'packages':['gauge']});
      window.google.charts.setOnLoadCallback(() => {
        if (this.$refs.chart == undefined)
          return;
        this.chart = new window.google.visualization.Gauge(this.$refs.chart);
        this.refresh();
      });
    }
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardCaskingSummary($from:Date!, $to:Date!, $period:SummaryPeriod!) {
                                            caskingSummary(from:$from, to:$to, period:$period) {
                                              total,periodStart
                                            }
                                          }`, {from:this.from, to:this.to, period:this.period});
      if (!results.error) {

        this.max = 0;
        for (const period of results.data.caskingSummary)
          this.max = this.max > period.total ? this.max : period.total;
        this.max = Math.ceil(this.max);
        if (this.max == 0)
          this.max = 1000;

        // Do data for gauge
        let n = results.data.caskingSummary.length-1;
        if (n !== -1 && results.data.caskingSummary[n].periodStart < format(add(new Date(), {days:-30}), 'yyyy-MM-dd'))
          n = -1;
        this.dataGauge = [['Label','Value'],['Casks',n==-1?0:results.data.caskingSummary[n].total]];

        this.draw();
      }
    },
    draw() {
      if (this.chart === null)
        return;

      const formatter = new window.google.visualization.NumberFormat({fractionDigits: 0});
      const data = window.google.visualization.arrayToDataTable(this.dataGauge);
      formatter.format(data, 1);

      this.options.max = this.max;
      this.options.greenFrom = .9 * this.options.max;
      this.options.greenTo = this.options.max;
      this.options.yellowFrom = .75 * this.options.max;
      this.options.yellowTo = .9 * this.options.max;

      this.chart.draw(data, this.options);
    }
  }
}
</script>